import { useCallback, useState } from 'react';

/**
 * 記錄「目前有幾個篩選條件有值」，給手機版「篩選」按鈕的 Badge 用。
 * 篩選欄位都是 uncontrolled（只往上丟 onChange），所以在這裡另外記一份布林即可。
 */
export function useActiveFilters(): { count: number; mark: (key: string, on: boolean) => void } {
  const [keys, setKeys] = useState<Record<string, boolean>>({});
  const mark = useCallback(
    (key: string, on: boolean) => setKeys((s) => (s[key] === on ? s : { ...s, [key]: on })),
    [],
  );
  return { count: Object.values(keys).filter(Boolean).length, mark };
}
